<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Drawer from "@/components/drawer";

// custom components
import PageHeader from "@/components/page-header";
import StaffHealthQueAns from "@/components/staffHealthQueAns.vue";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import hkService from "@/helpers/APIService/hk.service";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";

export default {
  name: "Staff_Health_Question_Sheet",
  props: {
    currentProps: Object,
  },
  components: {
    PageHeader,
    DatePicker,
    Drawer,
    StaffHealthQueAns,
  },
  data() {
    return {
      title: "Staff Health Question Sheet",
      test: false,
      tabIndex: 0,
      selectedDate: moment().format("YYYY-MM-DD"),
      Table: {
        tableData: [],
        isDataLoading: true,
      },
      staffHealthSheetId: "",
      questionId: "",
      openStaffHealthQueAns: false,
    };
  },
  watch: {
    selectedDate: function (val) {
      if (val !== null) {
        this.selectedDate = moment(val).format("YYYY-MM-DD");
        this.getStaffHealthQuestionList();
      }
    },
  },
  computed: {
    ...authComputed,
    staffHelthSheetProps() {
      return {
        staffHelthSheetData: {
          Id: this.staffHealthSheetId,
          date: this.selectedDate,
        },
      };
    },
  },
  mounted() {
    this.getStaffHealthQuestionList();
  },
  methods: {
    // Method is for get health question list
    getStaffHealthQuestionList() {
      this.Table.isDataLoading = true;
      hkService
        .getStaffHealthSheetList(this.selectedDate)
        .then((response) => {
          this.Table.tableData = response;
          this.Table.isDataLoading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for show drop down
    showDropDown(id) {
      this.questionId = id;
    },
    // Method is use for change status
    changeStatus(data) {
      UserService.updateStaffHealthSheet(data.id, {
        status: data.status,
      })
        .then(() => {
          Middleware.notification("status successfully changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
      this.questionId = "";
    },
    staffHelthQueAns(id) {
      this.staffHealthSheetId = id;
      this.openStaffHealthQueAns = !this.openStaffHealthQueAns;
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" text="Staff Helth Question Sheet" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-3 mb-3">
                <span class="d-flex">
                  <span class="me-2 mt-2"><b> Date:</b></span>
                  <date-picker
                    lang="en"
                    placeholder="MM-DD-YYYY"
                    v-model="selectedDate"
                    type="date"
                    value-type="format"
                  ></date-picker>
                </span>
              </div>

              <div class="col-md-9 mb-3">
                <div class="d-flex justify-content-end">
                  <span class="me-2"><b>Status :</b></span>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-circle text-success fs-5 mx-1"></i>
                    <p class="mb-0">Completed</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-circle text-warning fs-5 mx-1"></i>
                    <p class="mb-0">Pending</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-circle text-danger fs-5 mx-1"></i>
                    <p class="mb-0">Leave</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="table-responsive mb-0">
                <table
                  class="table table-hover mb-0"
                  ref="my-table"
                  infinite-scroll-disabled="busy"
                  infinite-scroll-distance="10"
                >
                  <thead class="table-light">
                    <tr>
                      <th>ID#</th>
                      <th>Date</th>
                      <th>User</th>
                      <th>Created By</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody v-if="Table.isDataLoading">
                    <tr v-for="(item, index) in 10" :key="index">
                      <td class="placeholder-glow" v-for="no in 6" :key="no">
                        <span class="placeholder w-100 placeholder-lg"></span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr v-for="(data, index) in Table.tableData" :key="index">
                      <td @click="staffHelthQueAns(data.id)">
                        {{ data.sheet_id }}
                      </td>
                      <td @click="staffHelthQueAns(data.id)">
                        {{ global_format_date(data.created_at) }}
                      </td>
                      <td @click="staffHelthQueAns(data.id)">
                        {{ data.staff_user.name }}
                      </td>
                      <td @click="staffHelthQueAns(data.id)">
                        {{ data.updated_by }}
                      </td>
                      <td>
                        <select
                          v-if="questionId == data.id"
                          name="status"
                          :id="index"
                          class="form-select"
                          v-model="data.status"
                          @change="changeStatus(data)"
                        >
                          <option value="completed">Completed</option>
                          <option value="pending">Pending</option>
                          <option value="leave">Leave</option>
                        </select>
                        <span
                          v-b-popover.hover="'click to change status'"
                          v-else
                          class="badge align-items-center py-1 px-2 card-badge"
                          @click="showDropDown(data.id)"
                          :class="[
                            data.status == 'pending'
                              ? 'badge-soft-warning'
                              : data.status == 'leave'
                              ? 'badge-soft-danger'
                              : 'badge-soft-success',
                          ]"
                          >{{
                            data.status == "pending"
                              ? "Pending"
                              : data.status == "leave"
                              ? "Leave"
                              : "Completed"
                          }}
                        </span>
                      </td>
                      <td @click="staffHelthQueAns(data.id)">
                        <i
                          class="fas fa-eye"
                          v-b-popover.hover="'view question answer'"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                  <tbody
                    v-if="!Table.isDataLoading && Table.tableData.length == 0"
                  >
                    <tr>
                      <td colspan="9" class="text-center">
                        <img
                          src="@/assets/images/empty.svg"
                          class="img-fluid"
                          alt=""
                        />
                        <p>
                          <span class="text-secondary">No Data Found</span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Drawer
      @close="staffHelthQueAns()"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openStaffHealthQueAns">
        <StaffHealthQueAns :currentProps="staffHelthSheetProps" />
      </div>
    </Drawer>
  </div>
</template>
